import { Injectable } from '@angular/core';
import { RestService } from './rest/rest.service';
import { StorageModule } from '../utils/storage.module';
import { HttpErrorResponse } from '@angular/common/http';
import { TaggingGtmConnector } from '@afe/tagging/gtm-connector';
import { TaggingDynatraceEvent } from '@afe/tagging/dynatrace-connector';
import { PAGE_VIEWS, TRACKING_EVENTS, EVENT_CATEGORY, PAGE_VIEWS_CARD, PAGE_VIEWS_UNIFIED } from '../enum/tracking.enum';
import { TaggingEvent } from '@afe/tagging';

@Injectable({
    providedIn: 'root',
})


export class MonitoringService {

    public flowName: string;

    public path_list = [
        'oferta-de-cartao-unificado',
    ]

    constructor(
        private storage: StorageModule,
        public taggingGtmConnector: TaggingGtmConnector,
    ) { }

    pushUpdateCapiToken() {
        window.dataLayer.push({
            event: "update_capi",
            user: {
                eventID: "692ac313-d273-4c9c-ac7f-abd320a0ac04",
                pageviewGA: '/pf/funil/contas/abertura-de-conta/simplificada/token'
            }
        })
    }

    pushUpdateCapiDadosPessoais() {
        window.dataLayer.push({
            event: "update_capi",
            user: {
                eventID: "97a9b4d4-fdf9-4624-8ecb-05d07ab942ca",
                pageviewGA: '/pf/funil/contas/abertura-de-conta/conta-cartao/completar-cadastro/step-3a'
            }
        })
    }

    pushUpdateCapiEndereco() {
        window.dataLayer.push({
            event: "update_capi",
            user: {
                eventID: "87a9b4d4-fdf9-4624-8ecb-05d07ab942ca",
                pageviewGA: '/pf/funil/contas/abertura-de-conta/conta-cartao/endereco/step-3b'
            }
        })
    }

    checkDatalayerDimension() {
        const customDimensionsDatalayer: any = window.dataLayer.find((event: any) =>
        event.event === 'eventGA' &&
        event.action === 'aux'
        && event?.customDimensions);

        const storedCustomDimensions = this.storage.getDimensions();

        if (!customDimensionsDatalayer && storedCustomDimensions){
            this.sendCustomDimension(storedCustomDimensions);
        }
    }


/**
     *
     * @param customDimension
     * @param reset
     */
 sendCustomDimension(customDimension, reset = false) {
    const event = {
        'event': 'auxGA',
        'category': this.getEventCategory() ? this.getEventCategory() : 'portal:contapf',
        'action': 'aux',
        'label': 'coleta:tipo-de-fluxo',
        'nonInteraction': true,
        'customDimensions': customDimension
    };

    try {

        if (!reset) this.updateCustomDimensionsOnStorage(customDimension);
            this.taggingGtmConnector.tag(event);

    } catch (error) { }

}

    /**
     * Saves custom dimension on storage to persists even if the user refresh the browser page
     * @param customDimension
     */
     updateCustomDimensionsOnStorage(customDimension?) {
        let storageDimension = this.storage.getDimensions();
        storageDimension = {...storageDimension,...customDimension};
        this.storage.setDimesions(storageDimension);
    }
/**
     * Gets event category to apply on user action event
     * @param defaultCategory indicates if it's an default event, not depending wich flow the user belongs to
     * @returns
     */
 getEventCategory(defaultCategory:boolean=false):string {
    if(defaultCategory){
        return EVENT_CATEGORY['DEFAULT'];
    }

    this.flowName = this.storage.getFlowName();
    return EVENT_CATEGORY[!this.flowName ? 'portal:contapf' : this.flowName]
}

    checkEventCategory() {
        this.flowName = this.storage.getFlowName();
        return EVENT_CATEGORY[ !this.flowName ? 'portal:contapf' :  this.flowName ]
    }

    checkEventUrl(pathurl) {
        this.flowName = this.storage.getFlowName();
        switch (this.flowName) {
            case 'OPEN':
                return PAGE_VIEWS[pathurl]
            case 'MONO':
                return PAGE_VIEWS[pathurl]
            case 'UNIFIED':
                return PAGE_VIEWS_UNIFIED[pathurl]
            case 'CARD':
                return PAGE_VIEWS_CARD[pathurl]
            default:
                return PAGE_VIEWS[pathurl]
        }
        // return  !this.flowName  || this.flowName == 'OPEN' || this.flowName == 'MONO' ? PAGE_VIEWS[pathurl] : PAGE_VIEWS_CARD[pathurl]
    }

    getAndSetDimensionStorage(customDimension?) {
        const storageDatalayer = this.storage.getDimensions();
        const setNewCd = storageDatalayer && customDimension;
        let isEqual = false;

        if (setNewCd) {
            storageDatalayer.map( datalayer => {
                if (this.isEqual(datalayer, customDimension)) isEqual = true;
            })

            if (!isEqual) {
                storageDatalayer.push(customDimension)
                this.setStorageDimension(storageDatalayer);
                return;
            }

        } else {
            this.setStorageDimension(customDimension);
            return;
        }
    }

    setStorageDimension(customDimension) {
        if(Array.isArray(customDimension)) {
            this.storage.setDimesions(customDimension);
        } else {
            const storage = [];
            storage.push(customDimension);
            this.storage.setDimesions(storage);
        }
        return;
    }

    /**
     * Dispatch a pageview event to GTM Connector
     * @param pathurl page path (not the full URL)
     * @param complement aditional text to get custom path
     * @param isPageViewDialog indicator if it's a page view on dialog
     */
     send(pathurl: string, complement?: string, isPageViewDialog?: boolean) {
        let event;

        try {

            const pageView = this.storage.getPageView();

            // avoid send 2x the pageview in sequence(user can press F5 button and
            // it should not send again to avoid abandoned scenario)
            if (pageView != pathurl && pathurl || isPageViewDialog) {

                let resultPathurl = this.getPageviewFromPath(pathurl);

                if(resultPathurl){
                    resultPathurl = resultPathurl + (complement ? complement :  '')

                event = {
                    event: 'pageviewGA',
                    page: resultPathurl
                };

                if (event.page) {
                    this.storage.setPageView(resultPathurl);
                    this.taggingGtmConnector.tag(event);
                }
            }
        }
        }
        catch (e) { }
    }

    /**
     * Sends custom pageview not getting from PAGEVIEW ENUMs
     * @param pageView  full pageview text
     */
    sendStaticPageview(pageView:string) {
        let event:TaggingEvent;
        try {
            event = {
                event: 'pageviewGA',
                page: pageView
            };

            if (event.page) {
                this.storage.setPageView(pageView);
                this.taggingGtmConnector.tag(event);
            }
        }
        catch (e) { }
    }

    /**
     * Retrieves the page funel based on component path
     * @param pathurl the path defined on URL or in special case, an alias to different paths on same route
     * @returns the page to send to GA based on collect map
     */
     getPageviewFromPath(pathurl) {
        this.flowName = this.storage.getFlowName();
        switch (this.flowName) {
            case 'OPEN':
                return PAGE_VIEWS[pathurl]
            default:
                return PAGE_VIEWS[pathurl]
        }
    }

    /**
     * Validate and dispatch event GA if have no undefined value on attributes
     * @param event
     */
    sendValidEvent(event){
        try{
            const { category, action, label} = event;
            if(category && action && label){
                this.taggingGtmConnector.tag(event);
            }
        }
        catch(e){}
    }

    click(eventClick) {

        const event = {
            event: 'eventGA',
            nonInteraction: false,
            category: this.checkEventCategory() ? this.checkEventCategory() : 'portal:contapf',
            action: TRACKING_EVENTS.CLICKED,
            label: eventClick
        };

        const dynaEvent: TaggingDynatraceEvent = {
            action:TRACKING_EVENTS.CLICKED,
            event: 'eventGA',
            element: eventClick,
            isDirectInteraction: true
        }

        try {
            this.sendValidEvent(event);
        } catch (e) { }


    }

    select(eventClick) {
        const event = {
            event: 'eventGA',
            nonInteraction: false,
            category: this.checkEventCategory() ? this.checkEventCategory() : 'portal:contapf',
            action: TRACKING_EVENTS.SELECTED,
            label: eventClick
        };

        const dynaEvent: TaggingDynatraceEvent = {
            action:TRACKING_EVENTS.SELECTED,
            event: 'eventGA',
            element: eventClick,
            isDirectInteraction: true
        }

        try {
            this.sendValidEvent(event);
        } catch (e) { }


    }


    fill(eventClick) {
        const event = {
            event: 'eventGA',
            nonInteraction: false,
            category: this.checkEventCategory() ? this.checkEventCategory() : 'portal:contapf',
            action: TRACKING_EVENTS.FILLED,
            label: eventClick
        };

        const dynaEvent: TaggingDynatraceEvent = {
            action:TRACKING_EVENTS.FILLED,
            event: 'eventGA',
            element: eventClick,
            isDirectInteraction: true
        }

        try {
            this.sendValidEvent(event);
        } catch (e) { }


    }

    show(eventClick) {
        const event = {
            event: 'eventGA',
            nonInteraction: false,
            category: this.checkEventCategory() ? this.checkEventCategory() : 'portal:contapf',
            action: TRACKING_EVENTS.SHOW,
            label: eventClick
        };

        const dynaEvent: TaggingDynatraceEvent = {
            action:TRACKING_EVENTS.SHOW,
            event: 'eventGA',
            element: eventClick,
            isDirectInteraction: true
        }

        try {
            this.sendValidEvent(event);

        } catch (e) { }

    }

    sendErroGA(responseError:HttpErrorResponse) {
        this.erroHandler(responseError);
    }

    erroHandler(response: HttpErrorResponse) {

        let urlName = '';
        let statusCode = 0;
        let method = '';
        let countBar = 0;
        let title = '';

        if (!response) {
            return '';
        }

        if (response && response.url ) {
            urlName = response.url.replace('https://', '');
            urlName = urlName.split('?')[0];
        }

        statusCode = response.status;

        if (!response.status) {
            statusCode = 404;
        }

        if (response.error.title) title = response.error.title;

        const gtmEvent = {
            event: 'eventGA',
            nonInteraction: false,
            category: this.checkEventCategory() ? this.checkEventCategory() : 'portal:contapf',
            action: TRACKING_EVENTS.SHOW,
            label: `erro:${urlName}:${statusCode}:POST:${title}`,
        };


        let url_portal = 'commercial-portal';
        let index = gtmEvent.label.indexOf(url_portal)
        if (urlName && index == -1) this.taggingGtmConnector.tag(gtmEvent);
    }

    //Verifica se os objetos são iguais
    //Usado para evitar duplicidade ao disparar um evento de GA
    isEqual(systemCustom, sendCustom) {
        let keySystemCustom = Object.keys(systemCustom);
        let keySendCustom = Object.keys(sendCustom);

        if (keySystemCustom.length !== keySendCustom.length) return false;

        let diferent = keySystemCustom.some((key) => {
            return systemCustom[key] !== sendCustom[key];
        })

        return !diferent;
    }

    customEvent(customDimension, reset = false) {
        const event = {
            'event': 'auxGA',
            'category': this.checkEventCategory() ? this.checkEventCategory() : 'portal:contapf',
            'action': 'aux',
            'label': 'coleta:tipo-de-fluxo',
            'nonInteraction': true,
            'customDimensions': customDimension
        };

        try {
            let equal = false;
            let theLastAux: any = window.dataLayer.filter((i: any) => i.action === 'aux').pop();
            if (theLastAux) equal = this.isEqual(theLastAux.customDimensions, customDimension);
            if (!equal) {
                if (!reset) this.getAndSetDimensionStorage(customDimension);
                this.taggingGtmConnector.tag(event);
            }
        } catch (error) { }

    }

    productImpression(promotions) {
        const event = {
            'event': 'productImpression',
            'ecommerce': {
                'currencyCode': 'BRL',
                'impressions': promotions
            }
        }

        try {
            this.sendGaEvent(event);
        } catch (error) { }
    }



    productImpressionClick(promotion) {
        const event = {
            'event': 'productClick',
            'ecommerce': {
              'click': {
                'products': promotion
               }
            }
        }

        try {
            this.sendGaEvent(event);
        } catch (error) { }

    }

    purchase(id, totalPrice, products) {
        const event = {
            'event' : 'purchase',
            'ecommerce': {
                'currencyCode': 'BRL',
                'purchase': {
                    'actionField': {
                    'id': id,
                    'revenue': totalPrice,
                    'tax':'0',
                    },
                'products': products
              }
            }
        }
        try {
            this.sendGaEvent(event);
        } catch (error) { }

    }

    sendGaEvent(event)  {
        window.dataLayer.push(event);
    }

}
